import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

import { jsGrid } from "./jsFragmentGrid"
import DceWireEventDetails from "dce-fragments/lib/fragments/dceplugin/DceWireEventDetails";

interface GridProps {

}

@Dce("GridWithFragment")
export default class GridWithFragment extends DceComponent<GridProps> {

    private element: JQuery<HTMLElement>;

    private grid: jsGrid;

    private selectedChangeCallbacks: ((ids: any[]) => void)[] = [];

    constructor(elem: DceHTMLElement, props: GridProps | null) {
        super(elem, props);

        this.element = $(elem).first();

        this.grid = new jsGrid(
            this.element,
            props,
            (e: HTMLElement, a:string, t:string, ev: Event) => this.rowClick(e, a, t, ev),
            (elem: HTMLElement, grid:jsGrid, selected: string[], ev: Event) => this.selectedActionClick(elem, grid, selected, ev)
        );

        let resizeObserver = new ResizeObserver((entries, observer) => {
            console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX RESIZE");
            this.grid._setupBodySize();
        });

        resizeObserver.observe(elem.parentElement);

        (this.grid as any).setSelectedChangeCallback((ids:any) => {
            this.selectedChange(ids);
        });
    }


    onSimpleEvent(event: string) {

        if(event == 'saved'){
            this.refresh();
        }

        if(event == 'clearSelected'){
            this.grid.clearSelected();
        }

    }

    public refresh(): void {
        this.grid.refresh();
    }

    public addSelectedChangeCallback(callback: ((ids: any[]) => void)){
        this.selectedChangeCallbacks.push(callback);
    }

    public selectedChange(ids: any[]){
        console.log("-------- SELECTED CHANGE", ids);
        this.selectedChangeCallbacks.forEach(callback => {
            callback(ids);
        });
    }


    //self.actionCallback.call(this, self, self.selected);
    public selectedActionClick(elem: HTMLElement, grid:jsGrid, selected: string[], e: Event){

        let action = elem.dataset['wire'];

        let formData = new FormData();
        selected.forEach((v,s) => {
            formData.append("id[]", v);
        })

        elem.dispatchEvent(new CustomEvent<DceWireEventDetails>("dceWire", {
            bubbles: true,
            detail: {
                type: "click",
                element: elem,
                attr: action,
                originalEvent: e,
                formData: formData
            }
        }));

    }

    onSubComponentInit(component: string, elem: DceHTMLElement) {
        super.onSubComponentInit(component, elem);

        //
        // if(component == 'OpenDialog'){
        //     let od = elem.ext.getComponent('OpenDialog') as OpenDialog;
        //     od.addOnSavedClose((o, e) => {
        //         this.grid.refresh();
        //     });
        // }

    }

    public rowClick(elem: HTMLElement, action: string, target: string, e: Event){
        //
        // let opdialog = new OpenDialog(elem as DceHTMLElement, {
        //     target: target,
        //     url: action,
        //     bindClick: false
        // });
        //
        // opdialog.addOnClose((d, e) => {
        //     if (d.dialogIsNextStep || (!d.getFormBind() || (d.getFormBind() && d.getFormSaved()))) {
        //         this.grid.refresh();
        //     }
        // });
        //
        // opdialog.loadDialog();


        elem.dispatchEvent(new CustomEvent<DceWireEventDetails>("dceWire", {
            bubbles: true,
            detail: {
                type: "click",
                element: elem,
                attr: action,
                originalEvent: e
            }
        }));


    }

}
